import * as React from 'react';
import frLocale from 'date-fns/locale/fr';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {DesktopDatePicker} from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import '../../assets/css/demo.css';
import {styled} from '@mui/material/styles';

const DatePickerComponent = ({showDate, setDate, min, max, validated, disabled=false}) => {
  const [focus, setFocus] = React.useState(true);
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (focus) {
      inputRef?.current?.focus();
    }
  }, [focus]);

  const CssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
    },
    '& .MuiOutlinedInput-root.Mui-error': {
      '& fieldset': {
        borderColor: validated ? 'rgb(211,57,49)' : 'rgba(0, 0, 0, 0.23)',
      },
    },
    '& .MuiInputLabel-root.Mui-error': {
      color: validated ? 'rgb(211,57,49)' : 'rgb(108,117,125)',
    },
    '& .MuiOutlinedInput-root.Mui-error.Mui-focused': {
      '& fieldset': {
        borderColor: validated ? 'rgb(211,57,49)' : 'rgb(25,118,210)',
      },
    },
    '& label.Mui-focused.Mui-error': {
      color: validated ? 'rgb(211,57,49)' : 'rgb(25,118,210)',
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale} >
      <Stack spacing={3}>
        { disabled == false ?
          <DesktopDatePicker
            label={null}
            inputFormat='dd/MM/yyyy'
            minDate={new Date(min)}
            maxDate={new Date(max)}
            value={showDate} onChange={(e) => setDate(e)}
            renderInput={(params) => {
              return (
                <CssTextField
                  id='outlined-size-small'
                  defaultValue='Small'
                  size='small'
                  autoFocus={focus}
                  onFocus={() => setFocus(true)}
                  onBlur={() => setFocus(false)}
                  style={{zIndex: 1}}
                  {...params}
                />
              );
            }
            }
          /> :
          <DesktopDatePicker
            label={null}
            disabled
            inputFormat='dd/MM/yyyy'
            minDate={new Date(min)}
            maxDate={new Date(max)}
            value={showDate} onChange={(e) => setDate(e)}
            renderInput={(params) => {
              return (<CssTextField
                id='outlined-size-small'
                defaultValue='Small'
                size='small'
                autoFocus={focus}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                style={{zIndex: 1}}
                {...params}
              />);
            }}
          />
        }
      </Stack>
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
